import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import { FaSave, FaTimes } from 'react-icons/fa';
import { updateConnection } from '../services/customerService';
import { ToastContainer, toast, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// ✅ Use same toast pattern as AddCustomer
const showToast = (type, message) => {
  const configs = {
    success: {
      color: "#28a745",
      border: "2px solid #28a745",
    },
    error: {
      color: "#dc3545",
      border: "2px solid #dc3545",
    },
    warning: {
      color: "#ffc107",
      border: "2px solid #ffc107",
    },
    info: {
      color: "#17a2b8",
      border: "2px solid #17a2b8",
    },
  };

  const config = configs[type];

  toast[type](message, {
    position: "top-right",
    autoClose: 3000,
    transition: Bounce,
    style: {
      border: config.border,
      background: "transparent",
      color: config.color,
      boxShadow: "none",
      marginTop: "70px",
    },
    icon: false,
  });
};

const EditConnectionModal = ({ show, onHide, connection, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (connection) {
      setFormData({
        gas_type: connection.gas_type || 'lpg',
        cylinder_capacity: connection.cylinder_capacity || '14.2kg',
        security_deposit: connection.security_deposit || 0,
        regulator_number: connection.regulator_number || '',
        stove_details: connection.stove_details || '',
        connection_status: connection.connection_status || 'active',
      });
    }
  }, [connection]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      console.log("🔄 Updating connection:", connection.id, formData);
      await updateConnection(connection.id, formData);
      console.log("✅ Connection updated successfully!");
      showToast('success', 'Connection updated successfully! 🎉');
      if (onSuccess) onSuccess();
      setTimeout(() => onHide(), 500);
    } catch (error) {
      console.error('❌ Update connection error:', error);
      showToast('error', error.response?.data?.message || 'Failed to update connection');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ✅ ToastContainer with same config as AddCustomer */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        transition={Bounce}
      />

      <Modal show={show} onHide={onHide} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Connection</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Row className="g-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Gas Type</Form.Label>
                  <Form.Select name="gas_type" value={formData.gas_type || ''} onChange={handleChange}>
                    <option value="lpg">LPG</option>
                    <option value="png">PNG</option>
                    <option value="cng">CNG</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Cylinder Capacity</Form.Label>
                  <Form.Select name="cylinder_capacity" value={formData.cylinder_capacity || ''} onChange={handleChange}>
                    <option value="5kg">5kg</option>
                    <option value="14.2kg">14.2kg</option>
                    <option value="19kg">19kg</option>
                    <option value="47.5kg">47.5kg</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Security Deposit (₹)</Form.Label>
                  <Form.Control type="number" name="security_deposit" value={formData.security_deposit || 0} onChange={handleChange} min="0" />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Status</Form.Label>
                  <Form.Select name="connection_status" value={formData.connection_status || 'active'} onChange={handleChange}>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                    <option value="suspended">Suspended</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Regulator Number</Form.Label>
                  <Form.Control type="text" name="regulator_number" value={formData.regulator_number || ''} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Stove Details</Form.Label>
                  <Form.Control as="textarea" rows={2} name="stove_details" value={formData.stove_details || ''} onChange={handleChange} />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>
              <FaTimes className="me-2" /> Cancel
            </Button>
            <Button type="submit" disabled={loading} style={{ backgroundColor: "rgb(30, 58, 111)", border: "none", borderRadius: "30px", padding: "10px 24px" }}>
              {loading ? <Spinner animation="border" size="sm" /> : <><FaSave className="me-2" /> Update Connection</>}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default EditConnectionModal;